import React, { Component } from 'react';
import Firebase from 'firebase';
import { DataTable } from 'react-data-components';


export default class dsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabla: this.props.name,
            start: "0",
            end: "19",
            numFilas: 20
        }
    }

    componentWillMount() {
        var datasetsRef = Firebase.database().ref('datasets')
            .child(localStorage.client_id)
            .child(this.props.id)
            .child(this.props.name)
            .orderByKey();
        datasetsRef
            .once('value')
            .then(resp => {
                this.setState({ dataset: resp.val(), titulos: Object.keys(resp.val()[0]) });
            });
    }

    render() {
        var titles = [];
        this.state.titulos ?
            this.state.titulos.map((t) => {
                var tt = t;
                tt = tt.substring(tt.indexOf("_") + 1);
                titles.push({ title: tt, prop: t })
            })
            :
            ""

        return (
            <div className="row">
                {this.state.titulos ?
                    <DataTable
                        keys="id"
                        columns={titles}
                        initialData={this.state.dataset}
                        initialPageLength={15}
                        initialSortBy={{ prop: titles[0].prop, order: 'descending' }}
                        pageLengthOptions={[5, 20, 50, 100]}
                    />
                    : ""
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/datasets/dsList.js